import {hasCancelRequest} from "@/helpers/common";
import { clientRoles, localStorageKeys } from "@/enums/common";
import { email } from "@/helpers/auth";

const actions = {
  async setClients({commit }) {
    const that=this._vm;
    const url = "client/list";
    const data = {
      email: email()
    };

    try {
      const response=await that.$constants('axios').post(url, data);
      const clients=response.data;
      commit("setClients",clients);
      commit('common/setApisLoadStates',{api:'clients',isLoaded:true},{root:true});
    }catch (error){
      const notification={
        code:"urgent",
        title:"An error occurred during fetching clients.Please refresh the page and try again."
      };
      commit("notifications/setNotification",notification,{root:true})
    }
  },
  async setDataSources({ state, commit }) {
    const that = this._vm;
    const activeClientID = state.generalLocalStorageVariables.activeClientID;
    const data = { clientID: activeClientID };
    const url = "datasource/list";

    try{
      const response=await that.$constants('axios').post(url, data);
      const dataSources=response.data;
      commit("setDataSources",dataSources);
      commit('common/setApisLoadStates',{api:'dataSources',isLoaded:true},{root:true});
    }catch (error) {
      if (hasCancelRequest(error))return;
      const notification={
        code:"urgent",
        title:"An error occurred during fetching the data sources.Please refresh the page and try again."
      };
      commit("notifications/setNotification",notification,{root:true});
    }
  },
  async setAnalyticsGoals({ state, commit }) {
    const that = this._vm;
    const activeClientID = state.generalLocalStorageVariables.activeClientID;
    const url = `integrations/ga/clients/${activeClientID}/goals`;

    try{
      const response = await that.$constants("$http").get(url);
      const analyticsGoals = response.data.data;
      commit("setAnalyticsGoals", analyticsGoals);
      commit("common/setApisLoadStates", { api: "analyticsGoals", isLoaded: true }, { root: true });
    }catch (error) {
    }
  },
  async createBookmark({ state, commit }) {
    const that=this._vm;
    const activeClientID = state.generalLocalStorageVariables.activeClientID;
    const url = `v1/clients/${activeClientID}/bookmarks`;
    const data = {
      name: "Default",
    };

    try{

      const response = await that.$constants("$http").post(url, data);
      const bookmarkID = response.data.data;
      commit("changeGeneralLocalStorageVariables", {
        key: localStorageKeys.activeClientBookmarkID,
        value: bookmarkID
      });

    } catch (error) {

      if (hasCancelRequest(error)) return;

      const notification = {
        code: "urgent", title: "An error occurred during creating bookmark.Please refresh the page and try again."
      };
      commit("notifications/setNotification", notification, { root: true });
    }
  },
  async setActiveBookMarkID({ state, commit, dispatch }) {
    const that = this._vm;
    const activeClientID = state.generalLocalStorageVariables.activeClientID;
    const url = `v1/clients/${activeClientID}/bookmarks`;

    try {

      const response = await that.$constants("$http").get(url);
      const bookmarks = response.data.data;

      if (bookmarks.length > 0) {
        const bookmarkID = bookmarks[0]._id;

        commit("changeGeneralLocalStorageVariables", {
          key: localStorageKeys.activeClientBookmarkID,
          value: bookmarkID
        });
        commit("setApisLoadStates", { api: "bookmarkID", isLoaded: true });

      } else {
        dispatch("createBookmark");
      }

    } catch (error) {

      if (hasCancelRequest(error)) return;

      const notification = {
        code: "urgent",
        title: "An error occurred during fetching active client bookmarks.Please refresh the page and try again."
      };
      commit("notifications/setNotification", notification, { root: true });

    }
  },
  async setIntegrations({ state, commit }) {
    const that = this._vm;
    const data = {
      clientID: state.generalLocalStorageVariables.activeClientID
    };

    const url = 'check-integrations';
    const config = { params: data };

    try {

      const response = await that.$constants('axios').get(url, config);
      const integrations = response.data;
      commit("setIntegrations", integrations);
      commit('common/setApisLoadStates', { api: 'integrations', isLoaded: true }, { root: true });

    } catch (error) {

      if (hasCancelRequest(error)) return;

      const notification = {
        code: "urgent",
        title: "An error occurred during fetching integrations.Please refresh the page and try again."
      };
      commit("notifications/setNotification", notification, { root: true });
    }
  },
  async setNotifications({ state, commit }) {
    const that=this._vm;
    const activeClientID = state.generalLocalStorageVariables.activeClientID;
    const data = {
      sortBy: "_id",
      sortOrder: "ascending",
    };
    const url = `v1/clients/${activeClientID}/notifications`;
    const config = { params: data };

    try{
      const response= await that.$constants('$http').get(url, config);
      const notifications=response.data.data;
      commit("setNotifications",notifications);
      commit("common/setApisLoadStates", { api: "notifications", isLoaded: true }, { root: true });
    }catch (error) {
      if (hasCancelRequest(error))return;

      const notification = {
        code: "urgent",
        title: "An error occurred during fetching the notifications.Please refresh the page and try again."
      };
      commit("notifications/setNotification",notification,{root:true})
    }

  },
  async getTaskReports({ rootState, state, commit }, reportID) {
    const that = this._vm;
    const activeClientID = state.generalLocalStorageVariables.activeClientID;
    const url = `v1/clients/${activeClientID}/reports/${reportID}`;

    try {

      const response = await that.$constants('$http').get(url);
      return response;

    } catch (error) {

      if (hasCancelRequest(error)) return;

      const notification = {
        code: "urgent",
        title: "An error occurred fetching task reports.Please refresh the page and try again."
      };
      commit("notifications/setNotification", notification, { root: true });

    }
  },
  async createDataSource({ rootState, state, commit }, data) {
    const that = this._vm;
    const activeClientID = state.generalLocalStorageVariables.activeClientID;
    const url = `v1/clients/${activeClientID}/datasources`;

    try {

      const response = await that.$constants('$http').post(url, data);
      return response;

    } catch (error) {

      if (error?.response?.status != 406) {
        const notification = {
          code: "urgent",
          title: "An error occurred during creating collection.Please refresh the page and try again."
        };
        commit("notifications/setNotification", notification, { root: true });
      }

      return error;
    }
  },
  async setGoogleAnalyticsAccounts({ state, commit }) {
    const that = this._vm;
    const activeClientID = state.generalLocalStorageVariables.activeClientID;
    const url = `integrations/ga/clients/${activeClientID}/accounts`;

    try{
      const response = await that.$constants("$http").get(url);
      if (!response) return;

      const data = {
        key: "googleAnalyticsAccounts",
        data: response.data.data.accounts
      };
      commit('setDataSourceData',data);
    }catch (error){
    }finally {
      commit('common/setApisLoadStates',{api:'googleAnalyticsAccounts',isLoaded:true},{root:true});
    }
  },
  async setGoogleAnalytics4Accounts({ state, commit }) {
    const that = this._vm;
    const activeClientID = state.generalLocalStorageVariables.activeClientID;
    const url = `integrations/ga4/clients/${activeClientID}/accounts`;

    try {
      const response = await that.$constants("$http").get(url);
      if (!response) return;

      const data = {
        key: "googleAnalytics4Accounts",
        data: response.data.data.accounts
      };
      commit("setDataSourceData", data);
    } catch (error) {
    } finally {
      commit("setApisLoadStates", { api: "googleAnalytics4Accounts", isLoaded: true });
    }
  },

  async setGoogleAdwordsAccounts({ state, commit }) {
    const that = this._vm;
    const activeClientID = state.generalLocalStorageVariables.activeClientID;
    const url =`integrations/gaw/clients/${activeClientID}/accounts`;

    try{
      const response = await that.$constants("$http").get(url);
      if (!response) return;

      const data={
        key: "googleAdwordsAccounts",
        data: response.data.data
      }
      commit('setDataSourceData',data);
    }catch (error){
    }finally {
      commit('common/setApisLoadStates',{api:'googleAdwordsAccounts',isLoaded:true},{root:true});
    }
  },
  async setFacebookAccounts({ state, commit }) {
    const that = this._vm;
    const activeClientID = state.generalLocalStorageVariables.activeClientID;
    const url = `integrations/f/clients/${activeClientID}/accounts`;

    try {

      const response = await that.$constants('$http').get(url);
      if (!response) return;
      const data = {
        key: 'facebookAccounts',
        data: response.data.data.accounts
      }
      commit('setDataSourceData', data);

    } catch (error) {

      if (error?.response?.status == 400 && error.response.data.data?.errorCode == "facebookNoConnection") {

        const notification = {
          code: "urgent",
        };
        const userRole = state.generalLocalStorageVariables.userRole;

        if (userRole == clientRoles.owner) {
          notification.title = `You need to reauthenticate your Facebook. Please <strong style="text-decoration: underline">click here </strong>  to verify.`;
        } else {
          notification.title = `Client owner (${state.activeClient.email}) need to reauthenticate Facebook.`;
        }

        commit("notifications/setNotification", notification, { root: true });
      }

    } finally {

      commit('common/setApisLoadStates', { api: 'facebookAccounts', isLoaded: true }, { root: true });

    }
  },
  async setGoogleSearchConsoleSites({rootState,state,commit}){
    const that=this._vm;
    const activeClientID=state.generalLocalStorageVariables.activeClientID;
    const url =`integrations/gsc/clients/${activeClientID}/sites`;
    try{
      const response=await that.$constants('$http').get(url);
      if (!response)return;
      const data={
        key:'googleSearchConsoleSites',
        data:response.data.data.sites
      }
      commit('setDataSourceData',data);
    }catch (error){
    }finally {
      commit('common/setApisLoadStates',{api:'googleSearchConsoleSites',isLoaded:true},{root:true});
    }
  },
  async getGoogleAnalyticsProperties({rootState,state,commit},data){
    const that=this._vm;
    const activeClientID = state.generalLocalStorageVariables.activeClientID;
    const config = { params: data };
    const url =`integrations/ga/clients/${activeClientID}/properties`;
    try{
      const response=await that.$constants('$http').get(url, config);
      return response;
    }catch (error){
    }finally {
      commit('common/setApisLoadStates',{ api:`googleAnalyticsAccount${data.accountId}Properties`,isCalled:true},{root:true});
      commit('common/setApisLoadStates',{api:`googleAnalyticsAccount${data.accountId}Properties`,isLoaded:true},{root:true});
    }
  },
  async getGoogleAnalytics4Properties({ rootState, state, commit }, data) {
    const that = this._vm;
    const config = { params: data };
    const activeClientID = state.generalLocalStorageVariables.activeClientID;
    const url =`integrations/ga4/clients/${activeClientID}/properties`;

    try {
      const response = await that.$constants("$http").get(url, config);
      return response;

    } catch (error) {
    } finally {

      commit("setApisLoadStates", { api: `googleAnalytics4Account${data.accountId}Properties`, isCalled: true });
      commit("setApisLoadStates", { api: `googleAnalytics4Account${data.accountId}Properties`, isLoaded: true  });

    }
  },
  async getGoogleAnalyticsViews({rootState,state,commit},data){
    const that=this._vm;
    const activeClientID=state.generalLocalStorageVariables.activeClientID;
    const config={params: data};
    const url =`integrations/ga/clients/${activeClientID}/views`;
    try{
      const response=await that.$constants('$http').get(url, config);
      return response;
    }catch (error){
    }finally {
      commit('common/setApisLoadStates',{api:`googleAnalyticsAccount${data.accountId}Views`,isCalled:true},{root:true});
      commit('common/setApisLoadStates',{api:`googleAnalyticsAccount${data.accountId}Views`,isLoaded:true},{root:true});
    }
  },
  async runPackage({ rootState, state, commit }, { packageID, options }) {
    const that = this._vm;
    const activeClientID = state.generalLocalStorageVariables.activeClientID;
    const url = `engine/clients/${activeClientID}/run-package/${packageID}`;
    const data = {
      ...options,
      user_email: email()
    }

    try {

      const response = await that.$constants('$http').post(url, data);

      return response.data;

    } catch (error) {

      if (error?.response?.data?.errorCode == 'wrongFilter') {

        return {
          errorCode: error.response.data.errorCode
        }

      } else if (hasCancelRequest(error)) {

        return {};

      }

      const notification = {
        code: "urgent",
        title: "An error occurred during running package.Please refresh the page and try again."
      };
      commit("notifications/setNotification", notification, { root: true });

      return {};

    }
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/common/actions.js